import * as datefns from 'date-fns';

export class DateUtil {
    static today(format = 'dd.MM.yyyy') {
        return datefns.format(new Date(), format);
    }

    static format(input, inputFormat = 'yyyy-MM-dd', format = 'dd.MM.yyyy') {
        const dateObj = datefns.parse(input, inputFormat, new Date());
        return datefns.format(dateObj, format);
    }

    static isValid(value: string, format = 'dd.MM.yyyy') {
        const dateObj = datefns.parse(value, format, new Date());
        return datefns.isValid(dateObj) && value.length === format.length;
    }

    static isInvalid(value, format?) {
        return !DateUtil.isValid(value, format);
    }

    /**
     * @deprecated function isInvalid offer the same functionality
     */
    static notValid(value, format?) {
        return !DateUtil.isValid(value, format);
    }

    static isInPast(value, format = 'dd.MM.yyyy') {
        const dateObj = datefns.parse(value, format, new Date());
        return datefns.isPast(dateObj);
    }

    static isInFuture(value, format = 'dd.MM.yyyy') {
        const dateObj = datefns.parse(value, format, new Date());
        return datefns.isFuture(dateObj);
    }

    static timeIsValid(value) {
        return DateUtil.isValid(value, 'HH:mm');
    }

    static isInPastWithTime(value, format = 'dd.MM.yyyy HH:mm') {
        return DateUtil.isInPast(value, format);
    }

    static fromService(value) {
        return value ? DateUtil.format(value, 'yyyy-MM-dd', 'dd.MM.yyyy') : '';
    }

    static toService(value) {
        return value && DateUtil.isValid(value) ? DateUtil.format(value, 'dd.MM.yyyy', 'yyyy-MM-dd') : null;
    }

    static isVonBisInvalidDate(from, to, format = 'MM.YYYY') {
        const fromDate = datefns.parse(from, format, new Date());
        const toDate = datefns.parse(to, format, new Date());
        return datefns.isAfter(fromDate, toDate);
    }

    static isBetweenAge(age: string, format: string = 'dd.MM.yyyy', minAge: number, maxAge: number): boolean {
        if (!age || !format || !minAge || !maxAge) {
            return false;
        }
        const ageDate = datefns.parse(age, format, new Date());
        const ageYears: number = datefns.differenceInYears(new Date(), ageDate);
        return maxAge > ageYears && ageYears >= minAge;
    }
}
